import React from "react";
import { object, number } from "prop-types";

import StoriesForLoadMore from "../stories-for-load-more";
import "./load-more-search-results.m.css";

class LoadMoreSearchResults extends React.Component {
  constructor(props) {
    super(props);
    const { total, stories, query } = props.data;

    this.state = {
      stories: stories,
      totalNumberOfStories: total,
      offset: stories.length,
      query: query,
      itemsToLoad: props.itemsToLoad || 4,
      noMoreStories: stories.length >= total
    };
  }

  loadMore = () => {
    const { itemsToLoad, offset, stories, query } = this.state;

    return global
      .wretch("/api/v1/search")
      .query({
        q: query,
        offset: offset,
        limit: itemsToLoad
      })
      .get()
      .json(response => {
        const updatedResults = [].concat(stories, response.results.stories);
        this.setState({
          stories: updatedResults,
          offset: offset + itemsToLoad,
          noMoreStories: updatedResults.length >= this.state.totalNumberOfStories
        });
      });
  };

  render() {
    const { stories, noMoreStories } = this.state;

    return (
      <div styleName="search-results-wrapper">
        {stories.length ? (
          <StoriesForLoadMore stories={stories} noMoreStories={noMoreStories} onLoadMore={this.loadMore} />
        ) : (
          <h3>No stories found...</h3>
        )}
      </div>
    );
  }
}

LoadMoreSearchResults.propTypes = {
  data: object,
  itemsToLoad: number
};

export default LoadMoreSearchResults;
